import { IUserState } from "../../../shared/interfaces/IUserState";

export const InitialState: IUserState = {
  firstName: "",
  lastName: "",
  email: "",
};
